export default (str: string) =>
  str
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove all accent marks
    .toLowerCase()
    .trim()
    .replace(/[\W_]+/g, '-') // Replace non-word chars with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
